<div class="daily-phrase" fxLayout="row" fxLayoutAlign="end center">
  <ng-container *ngIf="isLoading; else elseTemplate">
    <div class="spinner">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
  </ng-container>
  <ng-template #elseTemplate>
    <div class="text">
      <h3>"{{ showPhrase }}"</h3>
      <h5><i>{{ showPhraseAuthor }}</i></h5>
    </div>
  </ng-template>
</div>

